import { useEffect } from "react";
import styles from "./RendirectToDiscord.module.css";

function RedirectToDiscord() {
  useEffect(() => {
    window.location.href = "https://discord.gg/WPv7gYWbs6";
  }, []);

  return (
    <div className={styles.content}>
      <div className={styles.size}>Redirecionando para o Discord...</div>
    </div>
  );
}

export default RedirectToDiscord;
